// src/firebase-messaging.ts
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { app } from './firebase';
import { showToastNotification } from './utility/helper';
// Initialize messaging
export const messaging = getMessaging(app);

/**
 * Requests the user's permission to show notifications and retrieves the FCM token.
 * Replace 'YOUR_PUBLIC_VAPID_KEY' with your key from the Firebase console under Cloud Messaging.
 */
export const requestForToken = async (): Promise<string | null> => {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.log('Notifications are not supported on this device');
      return null;
    }
    if (Notification.permission !== 'granted') {
      // const permission = await Notification.requestPermission();
      //  If user blocked earlier, do not retry
      showToastNotification("warning", "Please enable notifications to receive updates.");
      if (Notification.permission === 'denied') {
        // const permission = await Notification.requestPermission();
        showToastNotification("warning", "Notifications are blocked. Please enable them in your browser settings to receive updates.");
        console.warn('Notifications are blocked by the user');
        return null;
      }

      //  Ask only if not decided
      if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return null;
      }
    }
    const registration = await navigator.serviceWorker.ready;
    console.log('registration', registration);
    const currentToken = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_API_KEY,
      serviceWorkerRegistration: registration,
    });
    console.log('currentToken', currentToken);
    if (currentToken) {
      return currentToken;
    } else {
      console.log(
        'No registration token available. Request permission to generate one.',
      );
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token. ', error);
    return null;
  }
};

export const onMessageListener = (): Promise<any> =>
  new Promise((resolve) => {
    onMessage(messaging, (payload: any) => {
      console.log('Message received. ', payload);
      if (Notification.permission === 'granted') {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.icon,
        });
      }
      resolve(payload);
    });
  });
